export const SERVICE_URLs = {
  userlogin: { url: "/login", method: "POST" },
  refreshToken: { url: "/refreshToken", method: "POST" },
  validatePageRefreshLogin: { url: "/validatePageRefreshLogin", method: "GET" },
  createCategory: { url: "/createCategory", method: "POST" },
  getAllCategories: { url: "/getAllCategories", method: "GET" },
  getAllBlog: { url: "/getAllBLogs", method: "GET" },
  getBlogById:{url:"getBlogById", method:"POST"},
  updateCategory: { url: "/updateCategory", method: "POST" },
  createBlog: { url: "/createBlog", method: "POST" },
  updateBlog: { url: "/updateBlog", method: "POST" },
};
